import React, { useRef, useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import JoditEditor from "jodit-react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CreatePageContent = () => {
  const editor = useRef(null);
  const navigate = useNavigate();
  const [contentid, setContentId] = useState("");
  const [contentname, setContentName] = useState("");
  const [contenttitle, setContentTitle] = useState("");
  const [content, setContent] = useState("");
  const [contenttype, setContentType] = useState("");
  const [pageid, setPageId] = useState("");
  const [pagelocationid, setPageLocationId] = useState("");
  const [isactive, setIsActive] = useState(1);

  const url = process.env.REACT_APP_API_URL;

  const [showCreateModal, setShowCreateModal] = useState(false)

  const handleCreate = async (e) => {
    e.preventDefault();
    setShowCreateModal(false)
    const pageData = {
      contentid,
      contentname,
      contenttitle,
      content,
      contenttype,
      pageid,
      pagelocationid,
    };

    if (
      !contentid ||
      !contentname ||
      !contenttitle ||
      !content ||
      !contenttype ||
      !pageid ||
      !pagelocationid
    ) {
      toast.error("Missing required parameters.", {
        position: "top-right",
        autoClose: 1000,
        theme: "colored",
      });
    } else {
      try {
        const headers = {
          'x-access-token': localStorage.getItem('jwttoken')
        };
        const response = await axios.post(
          url + "pagecontent/addNewData",
          pageData, { headers }
        );

        if (response.status === 201) {
          toast.success("Page created successfully", {
            position: "top-right",
            autoClose: 1000,
            theme: "colored",
          });
          setTimeout(() => {
            navigate("/pagecontentlist");
          }, 2000);
        } else {
          toast.error("Page was not added", {
            position: "top-right",
            autoClose: 1000,
            theme: "colored",
          });
        }
      } catch (err) {
        toast.error("An error occurred while creating the page.", {
          position: "top-right",
          autoClose: 1000,
          theme: "colored",
        });
      }
    }
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowCreateModal(true);
  };

  return (
    <>
      <div className="container mt-4">
        <div className="form-card">
          <div className="form-card-header">
            Add New Page Content
          </div>
          <div className="form-card-body">
            <Form onSubmit={handleSubmit}>

              {/* Row 1: Content ID & Content Name */}
              <Row className="mb-3">
                <Form.Group as={Col} controlId="contentid">
                  <Form.Label>Page Content Id:</Form.Label>
                  <Form.Control
                    type="text"
                    value={contentid}
                    onChange={(e) => setContentId(e.target.value)}
                    maxLength={50}
                  />
                </Form.Group>
                <Form.Group as={Col} controlId="contentname">
                  <Form.Label>Page Content Name:</Form.Label>
                  <Form.Control
                    type="text"
                    value={contentname}
                    onChange={(e) => setContentName(e.target.value)}
                    maxLength={100}
                  />
                </Form.Group>
              </Row>

              {/* Row 2: Content Title & Content Type */}
              <Row className="mb-3">
                <Form.Group as={Col} controlId="contenttitle">
                  <Form.Label>Page Content Title:</Form.Label>
                  <Form.Control
                    type="text"
                    value={contenttitle}
                    onChange={(e) => setContentTitle(e.target.value)}
                    maxLength={100}
                  />
                </Form.Group>
                <Form.Group as={Col} controlId="contenttype">
                  <Form.Label>Page Content Type:</Form.Label>
                  <Form.Control
                    type="text"
                    value={contenttype}
                    onChange={(e) => setContentType(e.target.value)}
                    maxLength={20}
                  />
                </Form.Group>
              </Row>

              {/* Page Content (JoditEditor) */}
              <Form.Group className="mb-3" controlId="content">
                <Form.Label>Page Content:</Form.Label>
                <JoditEditor
                  ref={editor}
                  value={content}
                  name="content"
                  className="form-control"
                  onChange={(newContent) => setContent(newContent)}
                />
              </Form.Group>

              {/* Row 3: Page Id & Page Location Id */}
              <Row className="mb-3">
                <Form.Group as={Col} controlId="pageid">
                  <Form.Label>Page Id:</Form.Label>
                  <Form.Control
                    type="number"
                    value={pageid}
                    onChange={(e) => setPageId(e.target.value)}
                  />
                </Form.Group>
                <Form.Group as={Col} controlId="pagelocationid">
                  <Form.Label>Page Location Id:</Form.Label>
                  <Form.Control
                    type="number"
                    value={pagelocationid}
                    onChange={(e) => setPageLocationId(e.target.value)}
                  />
                </Form.Group>
              </Row>

              {/* Form Actions */}
              <div className="form-actions">
                <button type="submit" className="btn-gradient-success">
                  Add Page
                </button>
                <Link to="/pagecontentlist" className="btn-back-link">
                  ← Back to List
                </Link>
              </div>
            </Form>
          </div>
        </div>

        <ToastContainer />

        <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Add New Page</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Sure you want to add page?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowCreateModal(false)}>
              Cancel
            </Button>
            <Button type="button" onClick={handleCreate} variant="primary" style={{ marginLeft: '10px' }}>
              Add Page
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default CreatePageContent;